import { EvScores, getEvDataScopeChangeFieldValue, hasEcovadisError } from 'services/common/EcovadisUtils';
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';
import EcovadisScoresButtons from './EcovadisScoresButtons';
import EcovadisScoreDetail from './EcovadisScoreDetail';
import EcovadisGlobalScore from './EcovadisGlobalScore';
import EcovadisScoresDates from './EcovadisScoresDates';
import { Context } from 'states/Store';
import { useContext, useEffect, useState } from 'react';
import { getEvHistory } from 'services/edge/EcovadisService';
import EcovadisScopeChangePopper from '../EcovadisScopeChangePopper';
import i18next from 'i18next';

const EcovadisScores = ({ evData, onRiskChange = () => {} }) => {
  const { classes } = useStyles();
  const [state] = useContext(Context);
  const [evScoreHistory, setEvScoreHistory] = useState();

  // Fetch Ecovadis Scores History
  useEffect(() => {
    async function fetchEcovadisScoreHistory() {
      try {
        const result = await getEvHistory(
          state.account.id,
          state.thirdparty.thirdpartyId,
          null
        );
        setEvScoreHistory(result.content?.map(ecovadisData => ecovadisData.ev_data));
      } catch (e) {
        setEvScoreHistory();
      }
    }
    if (state.account && state.thirdparty && !hasEcovadisError(evData)) {
      fetchEcovadisScoreHistory();
    }
  }, [state.account, state.thirdparty, evData]);

  return (
    <div className={classes.scoresWrapper}>
      <EcovadisGlobalScore evData={evData} />
      <div className={classes.scoresDataWrapper}>
        <div className={classes.scoresButtonsWrapper}>
          <EcovadisScoresButtons
            evData={evData}
            evScoreHistory={evScoreHistory}
            onRiskChange={onRiskChange}
          />
        </div>
        <div className={classes.scoresAndDatesWrapper}>
          <div className={classes.scoresDetailTitleWrapper}>
            <div className={classes.scoresDetailTitle}>
              {i18next.t('ecovadis.ecovadisRisks')}
            </div>
            <div className={classes.scoresDetailWrapper}>
              {EvScores.map((score) => (
                <EcovadisScoreDetail
                  key={score}
                  score={score}
                  value={getEvDataScopeChangeFieldValue(evData, score)}
                />
              ))}
            </div>
          </div>
          <div className={classes.datesWrapper}>
            <EcovadisScoresDates evData={evData} />
          </div>
          {evData?.scope_change && (
            <EcovadisScopeChangePopper
              evData={evData}
              buttonStyle={{
                right: '-6px',
                bottom: '-12px',
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EcovadisScores;
